import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { curationsApiPath } from './apiPath';

const PutCurationsRequestParamsSchema = z
  .object({
    curationId: z.string(),
  })
  .describe('PutCurationsRequestParamsSchema');

/** OpenAPI `UpdateCurationV2Request` */
const PutCurationsRequestBodySchema = z
  .object({
    title: z.string().min(1),
    description: z.string().optional().default(''),
    type: z.string().optional(),
    goodsItems: z.array(z.number()),
    snapItems: z.array(z.string()),
  })
  .describe('PutCurationsRequestBodySchema');

const PutCurationsResponseDataSchema = z
  .object({
    curationId: z.union([z.string(), z.number()]),
    title: z.string(),
    description: z.string().optional(),
    goodsCount: z.number(),
  })
  .describe('PutCurationsResponseDataSchema');

const PutCurationsResponseSchema = createApiResponseSchema(PutCurationsResponseDataSchema);

type PutCurationsResponse = z.infer<typeof PutCurationsResponseSchema>;

// 두 스키마를 합친 스키마
const PutCurationsRequestSchema = z.object({
  params: PutCurationsRequestParamsSchema,
  body: PutCurationsRequestBodySchema,
});

type PutCurationsRequest = z.infer<typeof PutCurationsRequestSchema>;

export const putCurations = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(PutCurationsRequestSchema),
    async (request: PutCurationsRequest) =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.put<PutCurationsResponse>(
          urlJoin(curationsApiPath.putCurations(request.params.curationId)),
          request.body,
        );
        return response;
      }),
    validateApiResponse(PutCurationsResponseSchema),
  ),
);
